import { Card, CardContent, Grid } from '@mui/material';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ScrollableTabs, TabTextVariant, WsTitleBanner } from 'wisestep-base';

import { WsBreadCrumbs } from '../../../../../components/WsBreadCrumbs';
import useGetJob from '../../../../../features/emailSettings/hooks/useGetJob';
import {
  getDefaultTab,
  getJobEmailCampaignBreadCrumbsList,
  IJobCampaignEmailTabTypes,
  jobCampaignEmailTabs,
} from '../../../../../features/emailSettings/util/JobCampaignEmailHelper';
import { EmailCampaignAnalytics } from '../../emailCampaignAnlytics';
import { EmailCampaignResponse } from '../../emailCampaignResponse';
import { EmailCampaignSent } from '../../emailCampaignSent';

export const JobCampaignEmailLayout = () => {
  const [params] = useSearchParams();
  const type = (params.get('type') as IJobCampaignEmailTabTypes) ?? '';
  const jobId = params.get('jobId') ?? '';
  const [index, setIndex] = useState<number>(getDefaultTab(type));
  const { job } = useGetJob(jobId);
  const selectedIndex = (index: number) => setIndex(index);
  return (
    <Grid container rowGap={1}>
      <Grid>
        <WsBreadCrumbs
          breadCrumbsList={getJobEmailCampaignBreadCrumbsList(
            job?.title && job?.jobCode ? `${job.title} (${job.jobCode})` : 'Job Name'
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <WsTitleBanner
          title={job?.title && job?.jobCode ? `${job.title} (${job.jobCode})` : 'Job Name'}
          backButton={false}
        />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardContent sx={{ p: 1 }}>
            <ScrollableTabs
              defaultValue={index}
              scrollList={jobCampaignEmailTabs}
              getTabIndex={selectedIndex}
              variant={TabTextVariant.SUB_TITLE}
            />
            <Grid px={2}>
              {index == 0 && <EmailCampaignAnalytics />}
              {index == 1 && <EmailCampaignResponse />}
              {index == 2 && <EmailCampaignSent />}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
